<template>
  <div>
    <v-row>
      <v-col md="6" sm="12">
        <v-card>
          <v-img
            contain
            :src="currentUrl"
            max-height="500p"
          ></v-img>

          <v-card-title>Foto de capa</v-card-title>

          <v-card-subtitle>
            Sua foto de capa deve mostrar a personalidade da sua empresa. Essa foto será a primeira a ser exibida na sua ficha na Pesquisa Google e no Google Maps.
          </v-card-subtitle>

          <v-card-actions>
            <location-photos-modal :accountData="locationData" :bulk="bulk" :filters="filters"/>

            <confirm-modal
                v-if="currentMedia"
                :action="() => $store.dispatch('locationCoverPhotos/DELETE_LOCAL_PHOTO', currentMedia.id)"
                action-text="Excluir"
                action-color="error"
                title="Deseja excluir a imagem de capa?"
            />

            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>

      </v-col>
    </v-row>
  </div>
</template>

<script>
import LocationPhotosModal from '../Modals/LocationPhotosModal.vue'
import ConfirmModal from '@/components/ConfirmModal'
import {mapState} from 'vuex'
import {get} from 'lodash'

export default {
  name: "LocationPhotosTab",
  props: {
    locationData: Object,
    filters: Object,
    bulk: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentUrl() {
      if (this.bulk) {
        return null
      }
      const media = this.locationData && Array.isArray(Object.values(this.locationData.mediaItems)) && Object.values(this.locationData.mediaItems).find(media => {
        return media.location_association && media.active && media.location_association.category === 'COVER'
      })
      return media ? media.google_url : null
    },
    currentMedia() {
      const items = get(this.location, 'data.mediaItems')
      const media = Array.isArray(items) && items.find(i => {
        if(i.location_association.category === 'COVER') {
          return i
        }
      })
      return media
    },
    ...mapState({
      location: state => state.locations.location,
      imageUploaded: state => state.locationCoverPhotos.imageUploaded,
      imageUploadedError: state => state.locationCoverPhotos.imageUploadedError,
    })
  },
  components: {
    LocationPhotosModal,
    ConfirmModal
  },
};
</script>
